import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updatePassengerFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (!bookWidgetFieldsMasterConfig.passengerField?.disable) {
    let selectedPaxValue = retrieveSearchData.passenger.toString();

    const dropdownOptions = [
      ...updatedBookWidgetFields.passengerField.dropdownOptions.map((data) => ({
        ...data,
        selected: false
      }))
    ];

    const indexOfSelectedPaxValue = dropdownOptions.findIndex(
      ({ value }) => value === selectedPaxValue
    );

    if (indexOfSelectedPaxValue === -1) {
      selectedPaxValue = dropdownOptions[0].value;
      dropdownOptions[0].selected = true;
    } else {
      dropdownOptions[indexOfSelectedPaxValue].selected = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      passengerField: {
        ...updatedBookWidgetFields.passengerField,
        selectedPaxValue,
        dropdownOptions,
        disable: false
      }
    };
  }

  return updatedBookWidgetFields;
};
